// @flow strict

import React from 'react';
import cx from 'classnames';
import { Link } from '../../internal/Button';
import PageContentBlock from '../../internal/PageContentBlock';
import type { InlineRichText, Layout } from '../../internal/types';
import styles from './styles.scss';
import ResponsiveImage from '../../internal/ResponsiveImage';

type BackgroundColor = 'Black' | 'Citrus' | 'White' | 'Silver' | 'Charcoal';

type PropTypes = {|
  title: string,
  backgroundColor: BackgroundColor,
  introText: InlineRichText,
  ctaText: string,
  href: string,
  secondCta?: string,
  secondHref?: string,
  altText?: string,
  image?: string,
  ticks?: string[],
  layout?: Layout,
|};

const backgroundMap = {
  Black: 'Dark',
  Citrus: 'Featured',
  White: 'White',
  Silver: 'Silver',
  Charcoal: 'Charcoal',
};

export default (props: PropTypes) => {
  const introTextStyles = props.backgroundColor === 'Black' ? styles.text : styles.blackText;
  return (
    <PageContentBlock
      background={backgroundMap[props.backgroundColor]}
      removePadding
      layout={props.layout}
    >
      <div className={styles.wrapper}>
        {props.image && (
          <ResponsiveImage
            className={styles.image}
            src={props.image}
            defaultSize={{ width: 130 }}
            alt={props.altText}
          />
        )}

        <div>
          <h1 className={styles.title}>{props.title}</h1>
          <div
            className={
              props.backgroundColor === 'Citrus'
                ? cx(introTextStyles, styles.citrusText)
                : introTextStyles
            }
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.introText }}
          />
          {props.ticks && props.ticks.length > 0 && (
            <ul className={styles.tickList}>
              {props.ticks.map((tick, index) => (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className={
                    props.backgroundColor === 'Citrus'
                      ? cx(styles.tick, styles.blackTick)
                      : styles.tick
                  }
                >
                  {tick}
                </li>
              ))}
            </ul>
          )}
        </div>

        {props.href && (
          <div className={styles.ctaContainer}>
            <Link href={props.href}>{props.ctaText}</Link>
            {props.secondHref && props.secondCta && (
              <Link href={props.secondHref} variant="Accent">
                {props.secondCta}
              </Link>
            )}
          </div>
        )}
      </div>
    </PageContentBlock>
  );
};
